import api from './index'
import { axios } from '@/utils/request'

export function createQuestion(parameter) {
    return axios({
        url: api.BaseURL + api.Question + 'create',
        method: 'POST',
        data: parameter
    })
}

export function getListQuestion(parameter) {
    return axios({
        url: api.BaseURL + api.Question + 'list',
        method: 'GET',
        params: parameter
    })
}

export function getDetailQuestion(parameter) {
    return axios({
        url: api.BaseURL + api.Question + 'detail',
        method: 'GET',
        params: parameter
    })
}

export function updateQuestion(parameter) {
    return axios({
        url: api.BaseURL + api.Question + 'update',
        method: 'POST',
        data: parameter
    })
}

export function updateSortQuestion(parameter) {
    return axios({
        url: api.BaseURL + api.Question + 'update_sort_question',
        method: 'POST',
        data: parameter
    })
}

export function deleteQuestion(parameter) {
    return axios({
        url: api.BaseURL + api.Question + 'delete',
        method: 'POST',
        data: parameter
    })
}

export function GetQuestionByFilter(parameter) {
    return axios({
        url: api.BaseURL + api.Question + 'get_question_by_filter',
        method: 'POST',
        data: parameter
    })
}

export function createListQuestion(parameter) {
    return axios({
        url: api.BaseURL + api.Question + 'create_list_question',
        method: 'POST',
        data: parameter
    })
}